'use client';

import styled from 'styled-components';

import { breakpoints, colors } from '@/styles/theme';

export const Container = styled.article`
  display: flex;

  flex-direction: column;
  justify-content: center;
  align-items: center;

  gap: 32px;

  @media (max-width: ${breakpoints.laptop}) {
    padding: 40px 0;
  }

  @media (max-width: ${breakpoints.mobile}) {
    padding: 36px 0;
  }
`;

export const Heading = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  gap: 32px;
`;

export const Meta = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  width: 100%;
  gap: 6px;

  font-size: 0.9rem;
  color: ${colors.gray5};
`;

export const Author = styled.div``;

export const Published = styled.div``;

export const FeaturedImage = styled.div``;

export const Content = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;
  margin: 0 auto;

  h1 {
    font-size: 2.2rem;
    font-weight: 500;

    margin: 15px 0 10px;
  }
  h2 {
    font-size: 2rem;
    font-weight: 500;

    margin: 15px 0 10px;
  }
  h3 {
    font-size: 1.8rem;
    font-weight: 500;

    margin: 15px 0 10px;
  }
  h4 {
    font-size: 1.6rem;
    font-weight: 500;

    margin: 15px 0 10px;
  }
  h5 {
    font-size: 1.4rem;
    font-weight: 500;

    margin: 15px 0 10px;
  }
  h6 {
    font-size: 1.2rem;
    font-weight: 500;

    margin: 15px 0 10px;
  }
  blockquote {
  }
  ul {
    padding-left: 24px;
  }
  ol {
  }
  a {
    text-decoration: underline;
    color: ${colors.aqua};
  }
  p,
  li {
    font-size: 1.2rem;
    line-height: 1.5;
    font-weight: 400;
    white-space: pre-wrap;
    overflow-wrap: break-word;
    margin: 5px 0;
  }
  code {
    background-color: #f4f4f4;
    border: 1px solid #ddd;
    border-left: 3px solid #000;
    color: #666;
    page-break-inside: avoid;
    font-family: monospace;
    font-size: 15px;
    line-height: 1.6;
    margin-bottom: 1.6em;
    max-width: 100%;
    overflow: auto;
    padding: 1em 1.5em;
    display: block;
    word-wrap: break-word;
  }

  @media (max-width: ${breakpoints.tablet}) {
    p {
      font-size: 1rem;
    }

    h1 {
      font-size: 2rem;
      margin: 10px 0 10px;
    }
    h2 {
      font-size: 1.8rem;
      margin: 10px 0 10px;
    }
    h3 {
      font-size: 1.6rem;

      margin: 10px 0 10px;
    }
    h4 {
      font-size: 1.4rem;

      margin: 10px 0 10px;
    }
    h5 {
      font-size: 1.2rem;

      margin: 10px 0 10px;
    }
    h6 {
      font-size: 1.1rem;

      margin: 10px 0 10px;
    }
    li {
      font-size: 1rem;
    }
    blockquote {
      margin: 1rem 0;
      padding: 4rem 0;
    }
    ul {
      margin: 10px 0 0 20px;
    }
    ol {
      margin: 10px 0 0 20px;
    }
  }
`;
